import { ConfigKey, IGetConfigValueProps, getConfigValue } from 'utils/environment';

/** @deprecated just use getConfigValue - TODO REMOVE THIS */
export const useConfigValue = <K extends ConfigKey>({
  key,
  defaultValue = '',
}: IGetConfigValueProps<K>) => {
  return getConfigValue({ key, defaultValue });
};
